module.exports = __webpack_public_path__ + "static/media/Illumise_gaussian2.cfa3f14f.png";